import React from 'react'
import { SVGIconProps } from 'commonTypes'
import SvgIcon from '@mui/material/SvgIcon'

const SearchIcon = ({ fill, ...props }: SVGIconProps) => {
    return (
        <SvgIcon viewBox="0 0 13 12" {...props}>
            <defs>
                <path
                    d="M15.2745898,13.8836847 L13.0486956,11.6577905 C12.9482289,11.5573238 12.8120408,11.501509 12.6691549,11.501509 L12.3052424,11.501509 C12.9214378,10.7134041 13.2875829,9.72213324 13.2875829,8.64379131 C13.2875829,6.07854313 11.2090397,4 8.64379146,4 C6.0785432,4 4,6.07854313 4,8.64379131 C4,11.2090395 6.0785432,13.2875826 8.64379146,13.2875826 C9.72213342,13.2875826 10.7134043,12.9214375 11.5015093,12.3052422 L11.5015093,12.6691546 C11.5015093,12.8120405 11.5573241,12.9482286 11.6577907,13.0486953 L13.883685,15.2745895 C14.0935486,15.4844531 14.4329026,15.4844531 14.6405337,15.2745895 L15.2723572,14.642766 C15.4822209,14.4329023 15.4822209,14.0935483 15.2745898,13.8836847 Z M8.64379147,11.5015093 C7.06534891,11.5015093 5.78607368,10.2244666 5.78607368,8.64379147 C5.78607368,7.06534891 7.06311632,5.78607368 8.64379147,5.78607368 C10.222234,5.78607368 11.5015093,7.06311632 11.5015093,8.64379147 C11.5015093,10.222234 10.2244666,11.5015093 8.64379147,11.5015093 Z"
                    id="path-1"
                ></path>
            </defs>
            <g
                id="BETEGKEZELÉS"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="01_Beteglista"
                    transform="translate(-966.000000, -94.000000)"
                >
                    <g
                        id="Form-/-Input"
                        transform="translate(720.000000, 70.000000)"
                    >
                        <g
                            id="Elements-/-Search"
                            transform="translate(242.899994, 20.000000)"
                        >
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#path-1"></use>
                            </mask>
                            <use
                                id="Mask"
                                fill={fill ?? 'currentColor'}
                                fillRule="nonzero"
                                xlinkHref="#path-1"
                            ></use>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export default SearchIcon
